"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategorizeChoiceItems = void 0;
const react_1 = __importDefault(require("react"));
const StackView_1 = require("../../../../StackView");
const Text_1 = require("../../../../Text");
const constants_1 = require("../../helpers/constants");
const CategorizeChoiceItem_1 = require("../CategorizeChoiceItem/CategorizeChoiceItem");
const CategorizeChoiceItems_styles_1 = require("./CategorizeChoiceItems.styles");
exports.CategorizeChoiceItems = react_1.default.memo(function CategorizeChoiceItems({ groups, onToggleItem, isSelected }) {
    return (react_1.default.createElement(CategorizeChoiceItems_styles_1.StyledCategorizeChoiceItems, { gap: StackView_1.STACK_GAP.xs, direction: StackView_1.STACK_DIRECTION.column }, groups.map(({ title: titleGroup, items }, groupKey) => {
        return (react_1.default.createElement(CategorizeChoiceItems_styles_1.StyledCategorizeChoiceItemsGroup, { key: `wrapper-group-${groupKey}` },
            react_1.default.createElement(CategorizeChoiceItems_styles_1.StyledCategorizeChoiceItemsTitle, { size: Text_1.TEXT_SIZE.m, weight: Text_1.TEXT_WEIGHT.bold }, titleGroup),
            items.map((item, optionKey) => {
                return (react_1.default.createElement(CategorizeChoiceItem_1.CategorizeChoiceItem, { key: `${groupKey}-${optionKey}`, "data-selector-id": item.testId ||
                        `${constants_1.dataSelectorId.partIdCheckbox}-${groupKey}-${optionKey}`, data: item, selected: isSelected(item.value), onToggle: onToggleItem }));
            })));
    })));
});
//# sourceMappingURL=CategorizeChoiceItems.js.map